// extracted by mini-css-extract-plugin
export default {"selectOrderCheckbox":"CheckboxCellRenderer_selectOrderCheckbox__IEp1d"};